module.exports = __webpack_public_path__ + "03fe63218d7b89759c61638b3342acfb.pdf";